import { ComponentType, lazy } from "react";

const LAST_RELOAD_KEY = "chunk-reload-at";
const RELOAD_GUARD_MS = 10_000;

/**
 * A tab opened before a deploy still runs the old `main.js`, which asks for chunk file names the
 * new build no longer serves. Reloading once picks up the new build; a second failure within the
 * guard window is a real error and is rethrown instead of reloading in a loop.
 */
export const reloadOnChunkError = <T>(
  factory: () => Promise<T>,
  reload: () => void = () => window.location.reload(),
): Promise<T> =>
  factory().catch((error: unknown) => {
    const lastReload = Number(sessionStorage.getItem(LAST_RELOAD_KEY) ?? 0);
    if (Date.now() - lastReload < RELOAD_GUARD_MS) {
      throw error;
    }
    sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
    reload();
    return new Promise<never>(() => {});
  });

export const lazyWithReload = <T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) => lazy(() => reloadOnChunkError(factory));
